import { Component } from '@angular/core';
import { SyncService } from 'src/app/core/services/SyncService/syncService.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-process-sync',
  templateUrl: './process-sync.component.html',
  standalone: true,
})
export class ProcessSyncComponent {
  constructor(
    private syncService: SyncService,
    private snackBar: MatSnackBar
  ) {}

  public syncOfflineProcesses(): void {
    this.syncService.syncOfflineProcesses().subscribe({
      next: () => {
        this.snackBar.open('Processos sincronizados com sucesso!', 'Fechar', {
          duration: 3000,
        });
      },
      error: () => {
        this.snackBar.open(
          'Erro ao sincronizar processos offline. Tente novamente.',
          'Fechar',
          {
            duration: 3000,
          }
        );
      },
    });
  }
}
